export const technology = {
  hero: {
    title: '实验室里的黑科技',
    subtitle: '前沿食品萃取科技',
    description: '膳兜兜的核心竞争力，源于对食品科学前沿技术的深度掌握与持续创新。我们将低温萃取、冻干锁鲜、微胶囊包埋等尖端技术，融入每一款产品的研发过程。',
  },
  labStats: [
    { label: '研发人员', value: '42', unit: '人' },
    { label: '专利数量', value: '18', unit: '项' },
    { label: '实验配方', value: '2000+', unit: '个' },
    { label: '检测标准', value: '300+', unit: '项' },
  ],
  technologies: [
    {
      shortName: 'Freeze Drying',
      name: 'FD冻干锁鲜技术',
      stat: '-40°C',
      statDesc: '真空冻干温度',
      description: '在零下40摄氏度的真空环境中，食材中的水分直接由固态升华为气态，全程无需经过液态。这一技术能最大程度保留食材的色、香、味及活性营养成分，锁鲜率高达98%以上。',
      benefits: ['营养保留率98%+', '复水性极佳', '无需防腐剂', '重量减轻90%'],
    },
    {
      shortName: 'Microencapsulation',
      name: '微胶囊靶向包埋',
      stat: '< 100μm',
      statDesc: '胶囊粒径控制',
      description: '利用天然壁材将活性成分（如人参皂苷、GABA、花青素等）包裹在微米级胶囊中。有效解决传统中药口感苦涩、易氧化失活的问题，实现肠道靶向释放，提高生物利用度。',
      benefits: ['掩盖不良风味', '防止氧化降解', '靶向肠道释放', '提高吸收率3x'],
    },
    {
      shortName: 'Cold Extraction',
      name: '低温冷萃提取',
      stat: '< 60°C',
      statDesc: '全程低温控制',
      description: '采用超低温溶剂萃取技术，在低于60°C的环境中提取植物活性成分。相比传统高温熬煮，冷萃技术能完整保留热敏性营养素（如维生素C、活性酶、多酚类物质）。',
      benefits: ['热敏营养零损失', '无高温焦化风险', '溶剂可回收', '提取纯度>95%'],
    },
    {
      shortName: 'Enzyme Engineering',
      name: '酶解风味工程',
      stat: '99%',
      statDesc: '豆腥味去除率',
      description: '通过精准控制的酶解反应，分解大豆、菌菇等食材中的异味前体物质。在保留蛋白质和膳食纤维的同时，彻底去除豆腥味和药味，只留食材本香。',
      benefits: ['保留完整蛋白', '去除苦涩异味', '提升口感层次', '增强消化率'],
    },
  ],
  process: {
    title: '研发六步法则',
    subtitle: '从原料到成品，每一款膳兜兜产品都经过严格的六步研发流程',
    steps: [
      { title: '原料溯源', desc: '全球36个优质产地直采，每批次DNA溯源检测' },
      { title: '成分分析', desc: 'HPLC高效液相色谱分析活性成分含量' },
      { title: '工艺研发', desc: '多变量正交实验，优化最佳工艺参数' },
      { title: '感官测评', desc: '百人感官小组盲测，数据化口感评分' },
      { title: '稳定性测试', desc: '加速老化实验，验证保质期营养稳定性' },
      { title: '量产放行', desc: '全批次第三方检测，清洁标签验证' },
    ],
  },
};